import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {StatesService} from "../state/states.service";
import {Scheduler} from "../../classes/scheduler/scheduler";

@Injectable({
    providedIn: 'root'
})
export class SchedulerService {

    constructor(private http: HttpClient, private stateService: StatesService) {
    }

    public getSchedulerByDeviceId(deviceId: number) {
        return this.http.get(`devices/` + deviceId + `/schedulers`);
    }

    public postScheduler(scheduler: Scheduler) {
        return this.http.post(`schedulers`, scheduler);
    }

    public patchScheduler(schedulerId: number, scheduler: Scheduler) {
        return this.http.patch(`schedulers/` + schedulerId, scheduler);
    }

    public deleteScheduler(schedulerId: number) {
        return this.http.delete(`schedulers/` + schedulerId);
    }
}
